// extracted by mini-css-extract-plugin
export default {"page":"VT-z","cartModal":"WT-z","checkout":"XT-z","placeholder":"YT-z","account":"ZT-z"};